import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { SetInitialStateFacade } from '../../../../../common/models/set-initial-state.facade';
import { HubItemFacade } from '../../hub/item/hub-item.facade';
import { CompartmentOverview } from '../models/compartment.model';
import {
  CompartmentItemCreate,
  CompartmentItemDelete,
  CompartmentItemInitialState,
  CompartmentItemNewCreate,
  CompartmentItemNewSsccId,
  CompartmentItemSetId,
} from './compartment-item.actions';
import { CompartmentItemState } from './compartment-item.state';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class CompartmentItemFacade implements SetInitialStateFacade {
  compartmentId$: Observable<number> = this.store.select(CompartmentItemState.getCompartmentId);
  newSsccId$: Observable<number> = this.store.select(CompartmentItemState.getSscdIdForNewCompartment);

  constructor(private store: Store, private hubItemFacade: HubItemFacade) {}

  setCompartmentId(id: number): void {
    this.store.dispatch(new CompartmentItemSetId(id));
  }

  createCompartment(compartmentOverview: CompartmentOverview): void {
    this.hubItemFacade.hubId$
      .pipe(take(1))
      .subscribe((hubId: number) => this.store.dispatch(new CompartmentItemCreate({ hubId, compartmentOverview })));
  }

  deleteCompartment(
    hubId: number,
    compartmentId: number,
    dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>,
  ): void {
    this.store.dispatch(new CompartmentItemDelete({ hubId, compartmentId, dialog }));
  }

  getSsccIdForNewCompartment(): void {
    this.hubItemFacade.hubId$
      .pipe(take(1))
      .subscribe((hubId: number) => this.store.dispatch(new CompartmentItemNewSsccId({ hubId })));
  }

  createNewCompartment(compartmentOverview: CompartmentOverview): void {
    this.hubItemFacade.hubId$
      .pipe(take(1))
      .subscribe((hubId: number) => this.store.dispatch(new CompartmentItemNewCreate({ hubId, compartmentOverview })));
  }

  setInitialState(): void {
    this.store.dispatch(new CompartmentItemInitialState());
  }
}
